export const provinces = {
    state: {
        provinceList: []
    },
    mutations: {
        SET_PROVINCE_LIST (state, payload) {
            state.provinceList = payload
        }
    },
    actions: {
        async fetchProvinceList({ state, commit }) {
            try {
                const response = await this.$api.get('api/provinces/list.json')

                commit('SET_PROVINCE_LIST', response.data.data)

                return response
            }catch(error) {
                console.error(error)
            }
        },
        async searchProvinceByName({ state, commit }, payload) {
            try {
                const response = await this.$api.get(`/api/provinces/search.json?q=${payload}`)

                return response
            } catch(error) {
                return error
            }
        }
    },
    getters: {
        provinceList: (state) => { return state.provinceList }
    }
}